import get from "lodash/get";
import PropTypes from "prop-types";
import React from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { defaultArray } from "redux-store/selectors";
import { Box } from "view/layout/box";

import { ApplicationViewChart } from "./application-view-chart.js";
import { ConnectionChart } from "./connection-chart.js";
import { StrategyChart } from "./strategy-chart.js";

class ChartsBox extends React.PureComponent {
  static get propTypes() {
    return {
      applications: PropTypes.object.isRequired,
      isThirdParty: PropTypes.bool.isRequired,
      stats: PropTypes.object.isRequired,
      strategies: PropTypes.object,
    };
  }

  render() {
    const { applications, isThirdParty, stats, strategies } = this.props;

    if (!stats) {
      return null;
    }

    const connectionData = get(stats, "stats.connection", defaultArray);
    const strategyData = get(stats, "stats.strategy", defaultArray);
    const viewData = get(stats, "stats.view", defaultArray);

    return (
      <Row className="device-charts-box">
        <Col xs={12}>
          <Row>
            <Col xs={isThirdParty ? 12 : 6}>
              <ConnectionChart data={connectionData} />
            </Col>
            {!isThirdParty && (
              <Col xs={6}>
                <StrategyChart strategies={strategies} data={strategyData} />
              </Col>
            )}
          </Row>
          <Row>
            <Col xs={12}>
              <Box title="Display Status" type="default">
                <ApplicationViewChart
                  applications={applications}
                  data={viewData}
                />
              </Box>
            </Col>
          </Row>
        </Col>
      </Row>
    );
  }
}

export { ChartsBox };
